<template>
  <div class="detail">
    <div class="content">
      <div class="navigation">
        <span>您当前的位置是：</span>
        <span @click="handleReturn">{{title}}</span>
        <span>> 详情</span>
      </div>
      <div class="text">
        <h2>{{obj.title}}</h2>
        <div class="time">
          <img src="../assets/author.png" alt="">
          <span style="margin-right: 30px">{{obj.author}}</span>
          <img src="../assets/time.png" alt="">
          <span style="margin-right: 30px">{{obj.a_time}}</span>
          <img src="../assets/browse.png" alt="">
          <span>{{obj.amount}}</span>
        </div>
        <div class="article">
          <div v-html="obj.article"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'detail',
    metaInfo () {
      return {
        title: this.obj.title,
        meta:[
          { name: 'discription',content: this.obj.title },
          { name: 'keywords', content: this.obj.title }
        ]
      }
    },
    data() {
      return {
        title: '首页',
        obj: {}
      }
    },

    mounted() {
      let params = this.$route.params
      if(params.type == 'index') this.title = '首页'
      if(params.type == 'note') this.title = '笔记'
      this.$http.get('article/get_article_detail', {id: params.id}, true).then(res => {
        if(res.data.code == 0){
          let obj = res.data.obj
          obj.amount = parseInt(obj.amount) + 1
          this.obj = obj
          this.$http.post('article/amount', {id: params.id, amount: obj.amount}, false).then(res => {}).catch(err => {})
        } else {
          this.$message.warning(res.data.msg)
          this.$router.replace('/404')
        }
      }).catch(err => {
        this.$message.error('网络有误！')
      })
      let scrolltop = document.documentElement.scrollTop || document.body.scrollTop
      if(scrolltop > 10){
        document.body.scrollTop = document.documentElement.scrollTop = 0
      }
    },

    methods: {
      handleReturn () {
        window.history.length > 1 ? this.$router.go(-1) : this.$router.replace('/')
      },
    }
  }
</script>

<style>
  .content {
    margin-bottom: 30px;
  }

  .content .navigation {
    padding: 20px 0 10px 0;
    border-bottom: 5px dashed #db6d4c;
    margin-bottom: 20px;
  }

  .content .navigation span:first-child {
    color: #000000;
    font-weight: bold;
  }

  .content .navigation span:nth-child(2):hover {
    color: #000000;
    text-decoration: underline;
    cursor: pointer;
  }

  .content .text {
    padding: 0 10px;
    box-sizing: border-box;
  }

  .content .text pre {
    overflow: auto;
    background-color: #000;
    box-sizing: border-box;
    padding: 5px 10px;
    border-radius: 10px;
  }

  .content .text h2 {
    color: #000000;
  }

  .content .text .time {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 20px;
  }

  .content .text .time img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .content .text .article {
    line-height: 30px;
  }

  .content .text .article img {
    width: 90%;
    margin: auto;
    display: block;
    /* text-indent: 2em; */
  }
</style>



// WEBPACK FOOTER //
// src/views/detail.vue